<template>
    <a-modal
        centered
        title="填写拒绝原因"
        :visible="visible"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="360"
        :confirmLoading="submitting"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="reject-create" :rules="rules">
            <a-form-model-item prop="failure_msg">
                <a-textarea v-model="form.failure_msg"></a-textarea>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        invoice_id: null,
        failure_msg: null,
    };
    export default {
        props: {
            visible: false,
            transaction_no: null,
            type: null,
            record: null,
            callback: null,
        },
        data() {
            return {
                submitting: false,
                form: null,
                rules: {
                    failure_msg: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "填写拒绝原因",
                        },
                    ],
                },
            };
        },
        watch: {
            visible() {
                this.form.transaction_no = this.transaction_no;
            },
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        methods: {
            on_ok() {
                this.$refs["reject-create"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.$http
                            .post(`/finance/audit/${this.type}/reject`, this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.$message.success(res.message);
                                    this.on_cancel();
                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({
                                        title: "失败",
                                        centered: true,
                                        content: res.message,
                                    });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            after_close() {
                this.form = JSON.parse(JSON.stringify(init_form));
                this.$refs["reject-create"].resetFields();
            },
            on_cancel() {
                this.$emit("close");
            },
        },
    };
</script>
